import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-assign-temporal-owner" },
    [
      _c(
        VForm,
        {
          ref: "form",
          staticClass: "form",
          attrs: { "lazy-validation": "" },
          on: { submit: _vm.onSubmit },
        },
        [
          !_vm.isForAllOwners
            ? _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.tplToWork &&
                      _vm.tplToWork.item &&
                      _vm.tplToWork.item.tableReference.tableId
                  )
                ),
              ])
            : _vm._e(),
          _vm.isForAllOwners
            ? _c(
                VRow,
                [
                  _c(
                    VCol,
                    { attrs: { sm: "12", lg: "12" } },
                    [
                      _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                        _vm._v(
                          "Only tables in 'prod' environment will be assigned"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "4" } },
                [
                  _c(VSubheader, { staticClass: "p-0 font-weight-bold" }, [
                    _vm._v("Email to assign"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "8" } },
                [
                  _c(VTextField, {
                    attrs: {
                      type: "email",
                      rules: [
                        function (v) {
                          return !!v || "E-mail is required"
                        },
                        function (v) {
                          return (
                            /[a-z0-9]+@[a-z]+.[a-z]{2,3}.[a-z]{2,3}/.test(v) ||
                            "E-mail must be valid"
                          )
                        },
                      ],
                      required: "",
                      placeholder: "Enter Value",
                      small: "",
                      dense: "",
                      outlined: "",
                    },
                    model: {
                      value: _vm.toSave.operator,
                      callback: function ($$v) {
                        _vm.$set(_vm.toSave, "operator", $$v)
                      },
                      expression: "toSave.operator",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.hideDate,
                  expression: "!hideDate",
                },
              ],
              attrs: { dense: "" },
            },
            [
              _c(
                VCol,
                { attrs: { sm: "4" } },
                [
                  _c(VSubheader, { staticClass: "p-0 font-weight-bold" }, [
                    _vm._v("Start date"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "8" } },
                [
                  _c(VTextField, {
                    attrs: {
                      type: "date",
                      required: !_vm.hideDate,
                      placeholder: "DD/MM/YYYY",
                      rules: !_vm.hideDate
                        ? [
                            function (v) {
                              return !!v || "Start Date is required"
                            },
                          ]
                        : [],
                      small: "",
                      dense: "",
                      outlined: "",
                    },
                    on: { change: _vm.fechas },
                    model: {
                      value: _vm.toSave.startDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.toSave, "startDate", $$v)
                      },
                      expression: "toSave.startDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.hideDate,
                  expression: "!hideDate",
                },
              ],
              attrs: { dense: "" },
            },
            [
              _c(
                VCol,
                { attrs: { sm: "4" } },
                [
                  _c(VSubheader, { staticClass: "p-0 font-weight-bold" }, [
                    _vm._v("Final date"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { sm: "8" } },
                [
                  _c(VTextField, {
                    attrs: {
                      type: "date",
                      required: !_vm.hideDate,
                      placeholder: "DD/MM/YYYY",
                      rules: !_vm.hideDate
                        ? [
                            function (v) {
                              return !!v || "Final Date is required"
                            },
                          ]
                        : [],
                      small: "",
                      dense: "",
                      outlined: "",
                    },
                    on: { change: _vm.fechas },
                    model: {
                      value: _vm.toSave.endDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.toSave, "endDate", $$v)
                      },
                      expression: "toSave.endDate",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { sm: "12", lg: "12" } },
                [
                  _c(
                    "b-alert",
                    { attrs: { show: _vm.invalidDate, variant: "danger" } },
                    [_vm._v("The Final Date must be higher than Start Date")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.dismissCountDown,
                        dismissible: "",
                        fade: "",
                        variant: "danger",
                      },
                      on: { "dismiss-count-down": _vm.countDownChanged },
                    },
                    [_vm._v("It is not possible to assign data operator")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-overlay", {
        attrs: {
          show: _vm.overlay,
          "no-wrap": "",
          rounded: "lg",
          opacity: "0.5",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }